<template>
  <div>
    <div class="facebook-icon" :style="style"></div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'FacebookLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
  computed: {
    style() {
      return `width: ${this.width}px; height: ${this.height}px;`;
    },
  },
};
</script>

<style lang="scss">
.facebook-icon {
  background-image: url('../../images/facebook-icon.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: inline-block;
  height: 64px;
  width: 64px;
}
</style>
